import React, { useEffect, useState } from "react";
import {useParams} from 'react-router-dom';
import { Slide, toast } from 'react-toastify';
import { LOGIN_LINK } from '../constants/constants';
import Header from "./Header";
import Footer from "./Footer";
import client from "../api";
import { notifyError, notifySuccess, refreshLocalStorage } from "../helper";

const ResetPasswordPage = () => {
    const api = client();
    const {token} = useParams();
    const [password,setPassword] = useState('');
    const [confirmPassword,setConfirmPassword] = useState('');
    const [error, setError]= useState({new_password:'',confirm_new_password:''});
    //const [confirmerror,setConfirmError]= useState('');
    const [loading,setLoading] = useState(false);

    const onFocus = (e) => {
        setError({...error, [e.target.name]:''}); 
    }

    const onBlur = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        if(!value.length){
            const msg = (name === 'new_password' ? 'New Password is required.' : (name === 'confirm_new_password' ? 'Confirm New Password is required.' :''));
            setError({...error, [e.target.name]:msg});
        }
    }

    const submitResetpassword = async () => {
        if(!password.length && !confirmPassword.length){
            setError({...error, ...{new_password:'New Password is required.', confirm_new_password:'Confirm New Password is required.'}});
        } else if(password.length && !confirmPassword.length){
            setError({...error, confirm_new_password:'Confirm New Password is required.'});
        } else if(!password.length && confirmPassword.length){
            setError({...error,new_password:'New Password is required.'});
        } else if(password !== confirmPassword){
            setError({...error, confirm_new_password:'Password confirmation failed. Both fields must match.'});            
        } else {
            try{
                setLoading(true);
                setError({new_password:'',confirm_new_password:''});
                const response = await api.post('/v1/user/resetPassword',{
                    token:token,
                    password:password
                })
                
                if(response.status === 200 || response.status === 201){
                    notifySuccess('Password is reset successfully');
                    refreshLocalStorage();
                    setLoading(false);
                    setTimeout(function(){
                       window.location.href = LOGIN_LINK;
                    },2000);
                }                    
            } catch(error) {
                console.log('error.message',error);
                setLoading(false);
                if(error.status === 400){ notifyError(error.message); }
            }
        }
       
    }
    // task 13
    // useEffect(()=>{
    //     refreshLocalStorage();
    // },[]);
    
    return(<>
    <Header/>
    <div className="login-page">
        <div className="login-block">
            <h2>Reset Password</h2>
            <p>Enter new password for your account and then you will be able to use them to login in your account.</p>
            <div className="form-wrap">
                <div className="field-wrap">
                    <label className="label">New Password</label>
                    <div className="input-wrap">
                        <input 
                            type="password" 
                            name="new_password" 
                            value={password}
                            onChange={(e)=>{
                                setPassword(e.target.value);
                            }}
                            onFocus={onFocus}
                            onBlur={onBlur}
                            />
                            {error.new_password && <div className="validation-error">{error.new_password}</div>}
                    </div>
                </div>
                <div className="field-wrap">
                    <label className="label">Confirm New Password</label>
                    <div className="input-wrap">
                        <input 
                            type="password" 
                            name="confirm_new_password" 
                            value={confirmPassword}
                            onChange={(e)=>{
                                setConfirmPassword(e.target.value);
                            }}
                            onFocus={onFocus}
                            onBlur={onBlur}
                            />
                            {error.confirm_new_password && <div className="validation-error">{error.confirm_new_password}</div>}
                    </div>
                </div>
                <div className="button-wrap center">
                    <button 
                        type="button" 
                        name="reset-submit" 
                        disabled={loading}
                        className={loading ? "submit-btn button--loading":"submit-btn"} 
                        onClick={()=>{
                            submitResetpassword();
                        }}><span className="button--text">Submit</span></button>
                </div>
            </div>
        </div>
    </div>
    <Footer/>
    </>);
}

export default ResetPasswordPage;